import { render, staticRenderFns } from "./SetProduct.vue?vue&type=template&id=483a41b4&"
import script from "./SetProduct.vue?vue&type=script&lang=ts&"
export * from "./SetProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports